import { DomainError } from '@/errors';

export class BookingError extends DomainError {
  get isBookingNotFound() {
    return this.code === 'SUMMARY_01';
  }
}
